import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";

const Player = () => {
  const { id } = useParams();
  const {
    user,
    token,
    setPending,
    navigate,
    setAlertMessage,
    setIsErr,
    setShowAlert,
    backendURL,
  } = useContext(PitchContext);

  const [player, setPlayer] = useState(null);
  const [requestText, setRequestText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedPlayer, setEditedPlayer] = useState({});

  const isOwner =
    user?.playerProfile?.profile[0]?.fullname === player?.fullname;

  const handleUpdatePlayer = async () => {
    console.log(editedPlayer);
    try {
      setPending(true);

      const res = await axios.post(
        `${backendURL}player/update/${id}`,
        editedPlayer,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.success) {
        setPlayer(res.data.updatedPlayer);
        setAlertMessage("Profil başarıyla güncellendi.");
        setIsErr(false);
        setShowAlert(true);
        setIsEditing(false);
      } else {
        setAlertMessage(res.data.message || "Güncelleme başarısız.");
        setIsErr(true);
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.response?.data?.message || "Bir hata oluştu.");
      setIsErr(true);
      setShowAlert(true);
    } finally {
      setPending(false);
    }
  };

  const handleSubmit = () => {
    setPending(true);
    axios
      .post(`${backendURL}player/send-request`, {
        email: player.email,
        invitedFullname: player.fullname,
        requesterFullname: user.fullname,
        note: requestText,
        phone: user.phone,
      })
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          axios
            .post(`${backendURL}player/update-quantity`, { playerID: id })
            .then((res) => {
              if (res.data.success) {
                setRequestText("");
                window.scrollTo(0, 0);
                setAlertMessage(response.data.message);
                setIsErr(false);
                setShowAlert(true);
              } else {
                setAlertMessage(response.data.message);
                setIsErr(true);
                setShowAlert(true);
              }
            })
            .catch((err) => {
              setPending(false);
              setAlertMessage(
                err.response?.data?.message || "Bir hata oluştu."
              );
              setIsErr(true);
              setShowAlert(true);
            });
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response?.data?.message || "Bir hata oluştu.");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  const handleTeamRequest = async () => {
    setPending(true);
    try {
      const response = await axios.post(backendURL + "team/oyuncu-ekle", {
        invitedID: player.user._id,
        requesterTeamID: user.team._id,
      });
      if (response.data.success) {
        setAlertMessage(response?.data?.message);
        setIsErr(false);
        setShowAlert(true);
      } else {
        setAlertMessage(response?.data?.message || "Bir hata oluştu.");
        setIsErr(true);
        setShowAlert(true);
      }
    } catch (err) {
      setAlertMessage(err.response?.data?.message || "Bir hata oluştu.");
      setIsErr(true);
      setShowAlert(true);
    } finally {
      setPending(false);
    }
  };

  const getPlayer = () => {
    setPending(true);
    axios
      .get(`${backendURL}player/get/${id}`)
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setPlayer(response.data.player);
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response?.data?.message || "Bir hata oluştu.");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    getPlayer();
    window.scrollTo(0, 0);
  }, []);

  if (!player) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse text-gray-500 text-lg">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100 transform transition-all duration-300 hover:shadow-xl">
        {/* Header */}
        <div className="relative bg-[#4d9041] p-8">
          <div className="flex justify-center">
            <div className=" bg-[#4d9041] rounded-lg w-full flex items-center justify-center h-50 ">
              {/* Circular green background behind profile image */}

              <div className="relative">
                <img
                  className="h-40 w-40 object-cover rounded-full border-4 border-white shadow-md transition-transform duration-300 hover:scale-105"
                  src={player.profileImage || "https://via.placeholder.com/150"}
                  alt={`${player.fullname || "Oyuncu"}'s profile`}
                />
                {isOwner && !isEditing && (
                  <button
                    onClick={() => {
                      setEditedPlayer({ ...player });
                      setIsEditing(true);
                    }}
                    className="absolute top-0 right-0 bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-md hover:bg-blue-700 transition-all cursor-pointer"
                  >
                    Düzenle
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 text-center">
          {isEditing ? (
            <input
              type="text"
              value={editedPlayer.fullname}
              onChange={(e) =>
                setEditedPlayer({ ...editedPlayer, fullname: e.target.value })
              }
              className="text-3xl font-bold text-gray-900 bg-transparent border-b-2 border-gray-300 focus:outline-none text-center"
            />
          ) : (
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
              {player.fullname || "Ad Belirtilmemiş"}
            </h1>
          )}
          {isOwner && !isEditing && (
            <p className="text-sm text-gray-500 mt-1">(Senin Profilin)</p>
          )}
          <div className="mt-3">
            {isEditing ? (
              <input
                value={editedPlayer.position}
                onChange={(e) =>
                  setEditedPlayer({
                    ...editedPlayer,
                    position: e.target.value,
                  })
                }
                className="bg-white text-[#4d9041] px-4 py-1 rounded-full shadow-sm text-sm font-medium focus:outline-none"
                placeholder="Pozisyon"
              />
            ) : (
              <span className="inline-block px-4 py-1 bg-[#4d9041]/10 text-[#4d9041] text-sm font-medium uppercase tracking-wider rounded-full shadow-sm transition-colors duration-200 hover:bg-[#4d9041]/20">
                {player.position || "Pozisyon Belirtilmemiş"}
              </span>
            )}
          </div>
          {isEditing && (
            <div className="mt-2">
              Resminizi profil sayfasındaki profilimi düzenle kısmından
              degiştirebilirsiniz
            </div>
          )}
        </div>

        {/* Player Info */}
        <div className="p-8">
          {/* Editable Fields */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8 bg-gray-50 p-6 rounded-xl shadow-inner border border-gray-100">
            {[
              ["Şehir", "city"],
              ["Yaş", "age"],
              ["Boy", "height"],
              ["Kilo", "weight"],
              ["Email", "email"],
            ].map(([label, key]) => (
              <div key={key} className="flex items-center justify-between">
                <label className="text-sm font-medium text-gray-600">
                  {label}:
                </label>
                {isEditing && key !== "email" ? (
                  <input
                    type={
                      ["age", "height", "weight"].includes(key)
                        ? "number"
                        : "text"
                    }
                    value={editedPlayer[key] || ""}
                    onChange={(e) =>
                      setEditedPlayer({
                        ...editedPlayer,
                        [key]: e.target.value,
                      })
                    }
                    className="w-2/3 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4d9041]"
                  />
                ) : (
                  <p className="text-gray-900 font-semibold text-sm text-right">
                    {key === "email"
                      ? player[key] || "N/A"
                      : key === "height"
                      ? player[key]
                        ? `${player[key]} cm`
                        : "N/A"
                      : key === "weight"
                      ? player[key]
                        ? `${player[key]} kg`
                        : "N/A"
                      : player[key] || "N/A"}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Description */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-700 mb-3">
              Hakkında
            </h2>
            {isEditing ? (
              <textarea
                value={editedPlayer.description || ""}
                onChange={(e) =>
                  setEditedPlayer({
                    ...editedPlayer,
                    description: e.target.value,
                  })
                }
                className="w-full p-4 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4d9041]"
                rows="4"
              />
            ) : (
              <p className="text-gray-600 leading-relaxed bg-gray-50 p-4 rounded-lg shadow-inner border border-gray-100">
                {player.description || "Bu oyuncu henüz kendini tanıtmadı."}
              </p>
            )}
          </div>

          {/* Save / Cancel Buttons */}
          {isEditing && (
            <div className="flex justify-center gap-4 mb-6">
              <button
                onClick={handleUpdatePlayer}
                className="bg-[#4d9041] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#62a556] transition-all cursor-pointer"
              >
                Kaydet
              </button>
              <button
                onClick={() => setIsEditing(false)}
                className="bg-gray-400 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-500 transition-all cursor-pointer"
              >
                İptal
              </button>
            </div>
          )}

          {/* Request Section */}
          {!isEditing && (
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-gray-700">
                İstek Gönder
              </h2>
              <textarea
                value={requestText}
                onChange={(e) => setRequestText(e.target.value)}
                placeholder="Mesajınızı yazın..."
                className="w-full p-4 border border-gray-200 rounded-xl resize-none shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4d9041]"
                rows="4"
              />
              {token ? (
                <>
                  <button
                    onClick={handleSubmit}
                    className="w-full bg-[#4d9041] text-white py-3 rounded-xl font-semibold hover:bg-[#62a556] transition-all cursor-pointer"
                  >
                    Maça Davet Et
                  </button>
                  <h3 className="text-lg font-semibold text-gray-700">
                    Oyuncuyu takımınıza eklemek için davet gönder
                  </h3>
                  <button
                    onClick={handleTeamRequest}
                    className="w-full bg-[#4d9041] text-white py-3 rounded-xl font-semibold hover:bg-[#62a556] transition-all cursor-pointer"
                  >
                    Davet Gönder
                  </button>
                </>
              ) : (
                <button
                  onClick={() => navigate("/giris-yap")}
                  className="w-full bg-[#4d9041] text-white py-3 rounded-xl font-semibold hover:bg-[#62a556] transition-all cursor-pointer"
                >
                  Davet atmak için giriş yapın
                </button>
              )}
            </div>
          )}

          {/* Match Count */}
          <div className="mt-8 text-center border-t border-gray-200 pt-6">
            <p className="text-gray-700 text-lg">
              Bu oyuncuya{" "}
              <span className="font-bold text-[#6ca87e]">
                {player.matchFindQuantity || 0}
              </span>{" "}
              kere{" "}
              <span className="font-semibold text-gray-800 uppercase bg-gray-100 px-2 py-1 rounded-md">
                HALISAHABUL
              </span>{" "}
              ile istek atıldı.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Player;
